import {update, makeKey} from '../../../../utils/reducerOperations';

export function verifyProcessStarted(state, payload) {
    return makeKey(
        'verifyPasswordApi',
        update(state.verifyPasswordApi, {isProcessing: true})
    );
}
